export const pencil = {
  pencil: {
    shape: `<path fill="#000" fill-opacity=".98" d="M5.3 19h1.08l9.9-9.9-1.08-1.07-9.9 9.9V19ZM18.43 8.37l-2.5-2.47.8-.8c.3-.32.67-.47 1.12-.47.45 0 .82.15 1.13.47l.64.65c.2.18.3.42.3.7 0 .28-.09.52-.27.7l-1.22 1.22Zm-.73.73L6.8 20H4.3v-2.5L15.2 6.6l2.5 2.5Z"/>`,
    viewBox: [0, 0, 24, 24],
  },
};
